<template>
  <div class="c-app flex-row align-items-center amsys-header">
    <CWrapper>
      <CHeader fixed with-subheader light style="position: fixed;">
        <CToggler
          in-header
          class="ml-3 d-lg-none"
          @click="$store.commit('toggleSidebarMobile')"
        />
        <CToggler
          in-header
          class="ml-3 d-md-down-none"
          @click="$store.commit('toggleSidebarDesktop')"
        />
        <CHeaderBrand class="d-lg-none">
          <h3>
            <b>
              <font color="Green">APPROVAL</font>
              <font color="gray">VECA</font></b
            >
          </h3>
        </CHeaderBrand>
        <CHeaderNav class="d-md-down-none mr-auto">
          <CHeaderNavItem class="px-3">
            <h3>
              <b>
                <font color="Green">APPROVAL</font>
                <font color="gray">VECA</font></b
              >
            </h3>
          </CHeaderNavItem>
        </CHeaderNav>
      </CHeader>
      <pull-to :top-load-method="refresh" @top-state-change="stateChange">
        <div class="top-load-wrapper">
          <CRow class="justify-content-center">
            <div id="loading-contentx" v-if="loadRefresh"></div>
          </CRow>
          <CRow class="justify-content-center">
            <div v-if="loadDone">
              Last Sync : {{ this.currentdate.getDate() }}/{{
                currentdate.getMonth() + 1
              }}/{{ currentdate.getFullYear() }} @
              {{ currentdate.getHours() }}:{{ currentdate.getMinutes() }}:{{
                currentdate.getSeconds()
              }}
            </div>
          </CRow>
        </div>
        <br />
        <div class="c-body">
          <main class="c-main" style="padding-top: 0;">
            <CRow>
              <div
                @click="clickOnVECACR()"
                v-if="this.showVeca"
                class="col-sm-6 col-md-x amsys-approval-card"
              >
                <div class="card text-white bg-gradient-danger">
                  <div class="card-body">
                    <div class="h2 mb-0">{{ ConsignmentCount }}</div>
                    <h6 class="text-muted text-uppercase font-weight-bold">
                      Consignment Request
                    </h6>
                    <div class="progress-xs my-3 mb-0 progress progress-white">
                      <div
                        role="progressbar"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        aria-valuenow="25"
                        class="progress-bar"
                        style="width: 50%;"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                @click="clickOnVECAPU()"
                v-if="this.showVeca"
                class="col-sm-6 col-md-x amsys-approval-card"
              >
                <div class="card text-white bg-gradient-success">
                  <div class="card-body">
                    <!---->
                    <div class="h2 mb-0">{{ PUCount }}</div>
                    <h6 class="text-muted text-uppercase font-weight-bold">
                      Consignment Price Update
                    </h6>
                    <div class="progress-xs my-3 mb-0 progress progress-white">
                      <div
                        role="progressbar"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        aria-valuenow="25"
                        class="progress-bar"
                        style="width: 50%;"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                @click="clickOnVECAQU()"
                v-if="this.showVeca"
                class="col-sm-6 col-md-x amsys-approval-card"
              >
                <div class="card text-white bg-gradient-warning">
                  <div class="card-body">
                    <!---->
                    <div class="h2 mb-0">{{ QUCount }}</div>
                    <h6 class="text-muted text-uppercase font-weight-bold">
                      Item Qty Update
                    </h6>
                    <div class="progress-xs my-3 mb-0 progress progress-white">
                      <div
                        role="progressbar"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        aria-valuenow="25"
                        class="progress-bar"
                        style="width: 50%;"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </CRow>
            <CRow class="justify-content-center">
              <CAlert color="primary" v-if="notif" id="notifError"> </CAlert>
            </CRow>
            <CRow class="justify-content-center">
              <div id="loading-contentx" v-if="loading"></div>
            </CRow>
          </main>
        </div>
      </pull-to>
    </CWrapper>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import PullTo from "vue-pull-to";
import CryptoJS from "crypto-js";
Vue.use(PullTo);

export default {
  name: "ApprovalVeca",
  components: {
    PullTo,
  },
  data() {
    return {
      results: [],
      FRCount: "0",
      CACount: "0",
      CRCount: "0",
      CSCount: "0",
      JLCount: "0",
      LNCount: "0",
      LRCount: "0",
      POCount: "0",
      PRCount: "0",
      SACount: "0",
      CsoCount: "0",
      CsrCount: "0",
      WoCount: "0",
      WoaCount: "0",
      WofCount: "0",
      ConsignmentCount: "0",
      PUCount: "0",
      QUCount: "0",
      showError: false,
      loading: false,
      notif: false,
      loadRefresh: false,
      loadDone: false,
      showFundRequest: false,
      showCashAdvanceRequest: false,
      showCashAdvanceSettlement: false,
      showPurchaseRequest: false,
      showPurchaseOrder: false,
      showStockAdjustment: false,
      showCapexRequest: false,
      showWorkOrder: false,
      showJobList: false,
      showConsignmentStockOrder: false,
      showConsignmentStockRequest: false,
      showWoAdditionalPart: false,
      showWoFinish: false,
      showVeca: false,
      iconLink: "",
      currentdate: new Date(),
      urlServer: "",
      urlVeca: "",
    };
  },
  methods: {
    async refresh(loaded) {
      let data = localStorage.token;
      let nav = JSON.parse(localStorage.navigation);
      console.log(nav);
      this.showVeca = nav[0].ApprovalVeca;
      //   this.showVeca = true;

      if (this.showVeca) {
        await this.GetVECAToken();
      }
      loaded("done");
    },
    async GetVECAToken() {
      const user = {
        userName: localStorage.user,
        password: "Rahasia2022#",
      };
      await axios
        .post(`${this.urlVeca}/Api/Authentication/Authenticate`, user, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "content-type": "application/json",
          },
        })
        .then(async (res) => {
          if (res.data != "failed") {
            localStorage.setItem("token-veca", res.data);
            await this.GetVECAApproval();
          } else {
            Vue.$toast.open({
              message: "Username Belum/Tidak terdaftar di Aplikasi VECA",
              type: "error",
              position: "bottom",
            });
          }
        })
        .catch(() => {
          Vue.$toast.open({
            message: "net:: ERR_CONNECTION_REFUSED",
            type: "error",
            position: "bottom",
          });
        });
    },
    async GetVECAApproval() {
      const token = localStorage.getItem("token-veca");
      await axios
        .all([
          this.getCRApproval(token),
          this.getPUApproval(token),
          this.getQUApproval(token),
        ])
        .then(
          axios.spread((CR, PU, QU) => {
            this.ConsignmentCount = CR.data.length;
            this.PUCount = PU.data.length;
            this.QUCount = QU.data.length;
          })
        )
        .catch(() => {
          Vue.$toast.open({
            message: "net:: ERR_CONNECTION_REFUSED",
            type: "error",
            position: "bottom",
          });
        });
    },
    async getCRApproval(token) {
      return axios.get(`${this.urlVeca}/Api/Approval/GetApprovalCRList`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });
    },
    async getPUApproval(token) {
      return axios.get(`${this.urlVeca}/Api/Approval/GetApprovalPUList`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });
    },
    async getQUApproval(token) {
      return axios.get(`${this.urlVeca}/Api/Approval/GetApprovalQUList`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });
    },
    stateChange(state) {
      if (state === "pull") {
        this.loadRefresh = false;
        this.loadDone = false;
      } else if (state === "trigger") {
        this.loadRefresh = true;
        this.loadDone = false;
      } else if (state === "loading") {
        this.loadRefresh = true;
        this.loadDone = false;
      } else if (state === "loaded-done") {
        this.loadRefresh = false;
        this.loadDone = true;
      }
    },

    clickOnVECACR() {
      this.$router.push({ path: "/ConsignmentRequest" });
    },
    clickOnVECAPU() {
      this.$router.push({ path: "/PriceUpdate" });
    },
    clickOnVECAQU() {
      this.$router.push({ path: "/QtyUpdate" });
    },
  },
  async beforeMount() {
    this.loading = true;
    const stringToProtect = "Amsys_2@2021";
    let url = CryptoJS.AES.decrypt(localStorage.url, stringToProtect);
    let urlVECA = CryptoJS.AES.decrypt(localStorage.urlVECA, stringToProtect);
    const urlS = url.toString(CryptoJS.enc.Utf8);
    const urlVECADec = urlVECA.toString(CryptoJS.enc.Utf8);
    this.urlServer = urlS;
    this.urlVeca = urlVECADec;
    let data = localStorage.token;
    let nav = JSON.parse(localStorage.navigation);
    console.log(nav);
    if (typeof data != "undefined") {
      axios
        .get(`${urlS}/Api/Approval/GetApprovalCount/`, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then(async (res) => {
          this.showVeca = nav[0].ApprovalVeca;
          //   this.showVeca = true;

          if (this.showVeca) {
            await this.GetVECAToken();
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;

          let err = error.toString();
          if (err.toString().match(/^.*undefined.*$/)) {
            Vue.$toast.open({
              message: "Sorry, Your token has expired!",
              type: "warning",
              position: "bottom",
            });
            this.$router.push({ path: "/logout" });
          } else {
            Vue.$toast.open({
              message: error,
              type: "error",
              position: "bottom",
            });
          }
        });
    } else {
      this.$router.push({ path: "/logout" });
    }
  },
};
</script>
